import React, { useState } from "react";
import { StyledCell, StyledRow } from "../common/ServicesList";
import { connect } from "react-redux";
import DragIcon from "@material-ui/icons/DragIndicator";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import SignatureIcon from "@material-ui/icons/Gesture";
import CameraIcon from "@material-ui/icons/CameraAlt";
import VerifiedIcon from "@material-ui/icons/HowToReg";
import DoneAllIcon from "@material-ui/icons/DoneAll";
import RemoveIcon from "@material-ui/icons/Remove";
import LateIcon from "@material-ui/icons/ErrorOutline";
import SoonerIcon from "@material-ui/icons/History";
import HomeIcon from "@material-ui/icons/Home";
import FlagIcon from "@material-ui/icons/Flag";
import MessageIcon from "@material-ui/icons/Message";
import { Typography, makeStyles, Divider, Checkbox } from "@material-ui/core";
import {
  getCountryName,
  capitalize,
  secondsToTime,
  hoursMinsFromSeconds
} from "../../utils/helpers";
import { Link, Chip } from "@material-ui/core";
import FreeBreakfastIcon from "@material-ui/icons/FreeBreakfast";
import CircleNumber from "../common/CircleNumber";
import OptimizedTooltip from "../common/OptimizedTooltip";
import clsx from "clsx";
import { routeColors } from "../data/constants";
import StopLeftIcon from "../project/StopLeftIcon";
import StopTimeInfo from "../project/StopTimeInfo";
import CachedIcon from "@material-ui/icons/Cached";
import { FormattedText } from "../common/FormattedText";

const useStyles = makeStyles(theme => ({
  tooltipBody: {
    maxWidth: 208,
    padding: theme.spacing(1.5, 1),
    "& p": {
      fontSize: ".8125rem !important",
      lineHeight: "15px"
    }
  },
  tooltipTitle: {
    marginBottom: theme.spacing(0.5)
  },
  noteText: {
    fontSize: ".8125rem !important",
    paddingLeft: "56px",
    marginTop: theme.spacing(-0.625),
    // borderBottom: "1px solid #eee",
    paddingBottom: theme.spacing(0.625)
  },
  divider: {
    background: "#eee"
  },
  noteBlock: {
    "& > div:first-of-type": {
      marginBottom: theme.spacing(2)
    }
  },
  checkBox: {
    padding: 8,
    "& .Mui-disabled": {
      cursor: theme.cursors.notAllowed
    }
  }
}));

function DragItem({
  item,
  index,
  isStartEnd,
  projectId,
  unassigned,
  editStop = () => null,
  deleteStop = () => null,
  print,
  projectStatus,
  daysPassed,
  locked,
  onMouseEnter = () => null,
  onMouseLeave = () => null,
  count,
  handleSelect = () => null,
  routeStatus,
  plan,
  startedRoute,
  active,
  selected,
  draggingCount,
  endLocationDefined,
  isDragging,
  solution,
  hasSelected,
  color,
  nextStart,
  className,
  editOnClick,
  stopInfo,
  disableHover,
  searchValue,
  setHaveHovered = () => {},
  haveHovered,
  activeByListCommand,
  ...otherProps
}) {
  const classes = useStyles();
  const [hovered, setHovered] = useState(false);

  // TODO: REMOVE THIS WHEN API IS OK
  daysPassed = 0;

  /*
  const indicatorColors = {
    finished: "#1329FE",
    skipped: "#F50057"
  };*/
  // Used when live updates are disabled
  const hideDetails =
    routeStatus === "in_progress" &&
    !plan.ft_live_status_updates &&
    item.type !== "start";

  // Used to disable drag
  locked = locked || item.status === "finished" || item.status === "skipped";

  const arr_time = hideDetails ? item.original_arr_time : item.arr_time;
  const end_time = hideDetails ? item.original_end_time : item.end_time;

  // Used to disable drag and to show stop status
  let published =
    ["published", "expired", "finished"].includes(
      projectStatus.toLowerCase()
    ) ||
    item.status === "finished" ||
    item.status === "skipped";

  const status = hideDetails ? "created" : item.status;

  const isBreak = item.type === "break";
  const isReload = item.type === "reload";
  const finishedOrSkipped = status === "finished" || status === "skipped";
  const tooltipTitle = title => {
    let titleText = title;
    if (title.props && title.props.text) {
      titleText = title.props.text;
    }
    if (titleText.length > 24) {
      return titleText;
    }
    return "";
  };

  let stopName = "";
  let stopAddress = "";

  if (!isBreak && item.information) {
    if (stopInfo) {
      stopName = stopInfo[0];
      stopAddress = stopInfo[1];
    } else if (item.information.recipient_name && !isStartEnd) {
      stopName = `${item.information.recipient_name || ""}`;
      stopAddress = `${item.information.street || ""}${
        item.information.street ? "," : ""
      }${item.information.city ? ` ${item.information.city}` : ""}${
        item.information.street
          ? ""
          : (item.information.city && item.information.country ? ", " : "") +
            (item.information.country
              ? getCountryName(item.information.country)
              : "")
      }`;
    } else {
      if (item.information.street) {
        stopName = `${isStartEnd ? item.information.house_number || "" : ""}${
          isStartEnd ? (item.information.house_number ? " " : "") : ""
        }${item.information.street || ""}`;
      } else {
        stopName = `${item.address.lat}, ${item.address.lng}`;
      }
      stopAddress = `${item.information.city || ""}${
        item.information.city && item.information.country ? ", " : ""
      }${
        item.information.country ? getCountryName(item.information.country) : ""
      }`;
    }
  }

  return (
    <>
      <StyledRow
        id={`stop-${item.id}`}
        isStartEnd={isStartEnd}
        isReload={isReload}
        published={published}
        onMouseEnter={() => {
          onMouseEnter(item);
          setHaveHovered(true);
          setHovered(true);
        }}
        onMouseLeave={() => {
          onMouseLeave();
          setHaveHovered(false);
          setHovered(false);
        }}
        haveHovered={haveHovered}
        active={active && !print}
        activeByListCommand={activeByListCommand}
        selected={selected && !print}
        data-cy={unassigned ? "dragItem-unscheduled" : "dragItem-scheduled"}
        className={clsx(
          className,
          finishedOrSkipped && !isBreak && !isReload && "finished-or-skipped"
        )}
        onClick={event => {
          if (editOnClick) {
            editStop(event, item.id, item.type, active, item.status);
          }
        }}
        {...otherProps}
      >
        {/* Index */}
        <StyledCell print={print} item className={clsx("first-col")}>
          {item.type === "start" ? (
            <HomeIcon style={{ color: color }} className="svg-icon" />
          ) : item.type === "end" ? (
            <FlagIcon style={{ color: color }} className="svg-icon" />
          ) : item.type === "break" ? (
            <FreeBreakfastIcon color="secondary" className="svg-icon" />
          ) : isReload ? (
            <CachedIcon
              style={{ color: color }}
              color="secondary"
              className="svg-icon"
            />
          ) : (
            <>
              {!print && !locked && (
                <div className={"drag-icon-wrapper"}>
                  <DragIcon
                    color="secondary"
                    fontSize="small"
                    className="drag-icon"
                  />
                </div>
              )}
              {!disableHover && (hasSelected || hovered) && (
                <OptimizedTooltip title="Select">
                  <Checkbox
                    checked={selected}
                    onClick={e => e.stopPropagation()}
                    onChange={() => handleSelect(item.id)}
                    color="primary"
                    className={classes.checkBox}
                  />
                </OptimizedTooltip>
              )}
              {(disableHover || !(hasSelected || hovered)) && (
                <>
                  {unassigned ? (
                    <StopLeftIcon />
                  ) : (
                    <div style={{ color: color }}>{count}</div>
                  )}
                </>
              )}
            </>
          )}
        </StyledCell>

        {/* Address */}
        <StyledCell
          print={print}
          item
          isStartEnd={isStartEnd}
          isReload={isReload}
          finished={item.status === "finished"}
          xs
          className="second-col"
        >
          {item.type === "break" ? (
            <>
              <Typography variant="body2" noWrap>
                Break time
              </Typography>
              <Typography className="text-13" color="secondary">
                {item.service_time / 60}m
              </Typography>
            </>
          ) : item.type === "reload" ? (
            <>
              <Typography variant="body2" noWrap>
                Reload
              </Typography>
              <Typography className="text-13" color="secondary" noWrap>
                {hoursMinsFromSeconds(nextStart.arr_time - item.arr_time)}
                {" • "}
                {`${stopName} ${stopAddress}`}
              </Typography>
            </>
          ) : item.type === "end" && endLocationDefined === false ? (
            <Typography variant="body2" noWrap color="secondary">
              End location not specified
            </Typography>
          ) : item.information ? (
            <>
              <OptimizedTooltip title={tooltipTitle(stopName)}>
                <Typography variant="body2" noWrap>
                  {searchValue &&
                  searchValue !== "" &&
                  typeof stopName === "string" ? (
                    <FormattedText text={stopName} query={searchValue} />
                  ) : (
                    stopName
                  )}
                </Typography>
              </OptimizedTooltip>
              <OptimizedTooltip title={tooltipTitle(stopAddress)}>
                <Typography className="text-13" color="secondary" noWrap>
                  {searchValue &&
                  searchValue !== "" &&
                  typeof stopAddress === "string" ? (
                    <FormattedText text={stopAddress} query={searchValue} />
                  ) : (
                    stopAddress
                  )}
                </Typography>
              </OptimizedTooltip>
            </>
          ) : null}
        </StyledCell>

        {/* Type / Requirements */}
        <StyledCell
          print={print}
          item
          isStartEnd={isStartEnd}
          isReload={isReload}
          xs={3}
          className="third-col"
        >
          {!isStartEnd && item.type !== "break" && item.type !== "reload" ? (
            <>
              <Typography variant="body2" style={{ color: "#7D7E82" }}>
                {capitalize(item.type)}
              </Typography>
              <div className={"requirements-wrapper"}>
                {item.requirements && (
                  <>
                    {(item.requirements.signature || item.signature) && (
                      <SignatureIcon className="requirement-icon" />
                    )}

                    {/* Use when barcode requirement will be added */}
                    {/* {(item.requirements.barcode || item.barcodes_scanned) && (
                    <BarcodeIcon className="requirement-icon" />
                  )} */}

                    {(item.requirements.age_verification ||
                      item.age_verified) && (
                      <VerifiedIcon className="requirement-icon" />
                    )}

                    {(item.requirements.picture || !!item.images?.length) && (
                      <CameraIcon className="requirement-icon" />
                    )}

                    {/* No requirements */}
                    {!(item.requirements.signature || item.signature) &&
                    !(
                      item.requirements.age_verification || item.age_verified
                    ) &&
                    !(item.requirements.picture || !!item.images?.length) ? (
                      <span className="dash-icon">—</span>
                    ) : null}
                  </>
                )}
              </div>
            </>
          ) : null}
        </StyledCell>

        {/* ETA / Time windows */}
        <StyledCell
          print={print}
          item
          isStartEnd={isStartEnd}
          isReload={isReload}
          xs
          className="fourth-col"
        >
          {!isStartEnd && !isBreak && item.type !== "reload" && (
            <StopTimeInfo
              unassigned={unassigned}
              stop={item}
              routeStatus={routeStatus}
              showAll={solution.showAll}
              liveStatusUpdates={plan.ft_live_status_updates}
            />
          )}
          {isStartEnd && (
            <Typography component="span" variant="body2">
              {secondsToTime(
                item.finish_time
                  ? item.finish_time
                  : item.type === "start"
                  ? end_time
                  : arr_time
              )}
            </Typography>
          )}
          {isStartEnd && !unassigned && (
            <Typography
              className="text-13"
              color="secondary"
              style={{ opacity: locked ? 1 : "", marginTop: 2 }}
            >
              {item.status === "finished" ? (
                <>{item.type === "start" ? "Started" : "Finished"}</>
              ) : (
                <>{item.type === "start" ? "Departure" : "Completion"} time</>
              )}
            </Typography>
          )}

          {/* Edit / Delete buttons
          {!isStartEnd && !print && !published && !locked && (
            <div className="edit-remove-btns">
              <Link
                component="button"
                onClick={e => {
                  console.log(active);
                  editStop(e, item.id, item.type, active, item.status);
                }}
                tabIndex="-1"
                data-cy={
                  unassigned ? "editStop-unscheduled" : "editStop-optimized"
                }
              >
                <OptimizedTooltip
                  placement="bottom"
                  title={
                    item.type === "break"
                      ? "Edit vehicle details"
                      : "Edit stop details"
                  }
                  enterDelay={300}
                  leaveDelay={100}
                >
                  <EditIcon />
                </OptimizedTooltip>
              </Link>

              <Link
                component="button"
                onClick={e => {
                  e.stopPropagation();
                  deleteStop({
                    open: true,
                    stop: item,
                    index: index + 1,
                    isEditing: active
                  });
                }}
                tabIndex="-1"
                data-cy={
                  unassigned ? "deleteStop-unscheduled" : "deleteStop-optimized"
                }
              >
                <OptimizedTooltip
                  placement="bottom"
                  title={item.type === "break" ? "Delete break" : "Delete stop"}
                  enterDelay={300}
                  leaveDelay={100}
                >
                  <DeleteIcon />
                </OptimizedTooltip>
              </Link>
            </div>
          )} */}
          {draggingCount && (
            <Chip
              className={"count-indicator"}
              classes={{
                label: "count-indicator-label"
              }}
              color="primary"
              label={draggingCount}
            />
          )}
        </StyledCell>
      </StyledRow>
      {print && (
        <>
          {item.information.notes && item.type !== "break" && (
            <Typography className={clsx(classes.noteText)} color="secondary">
              - - -
              <br />
              {item.information.notes}
            </Typography>
          )}
          <Divider className={classes.divider} />
        </>
      )}
    </>
  );
}

const mapStateToProps = (state, props) => {
  return {
    active:
      props.active !== undefined
        ? props.active
        : state.extendable.id === props.item.id
        ? 1
        : 0,
    selected:
      props.selected !== undefined
        ? props.selected
        : state.common.dragSelection.list.includes(props.item.id)
        ? 1
        : 0,
    draggingCount: props.isDragging
      ? state.common.dragSelection.list.length > 1
        ? state.common.dragSelection.list.length
        : false
      : false,
    plan:
      (state.auth.userData.organisationSite &&
        state.auth.userData.organisationSite.organisation.plan) ||
      {},
    solution: state.project.solution
  };
};

export default connect(mapStateToProps)(DragItem);
